const today = new Date();
let _seed = today.getFullYear() * 10000 + (today.getMonth() + 1) * 100 + today.getDate();

function next(): number {
  _seed = (_seed * 16807 + 0) % 2147483647;
  return (_seed - 1) / 2147483646;
}

export function pick<T>(arr: readonly T[]): T {
  return arr[Math.floor(next() * arr.length)];
}

export function pickN<T>(arr: readonly T[], n: number): T[] {
  const copy = [...arr];
  const max = Math.min(n, copy.length);
  for (let i = copy.length - 1; i > 0; i--) {
    const j = Math.floor(next() * (i + 1));
    [copy[i], copy[j]] = [copy[j], copy[i]];
  }
  return copy.slice(0, max);
}

export function pickAt<T>(arr: readonly T[], index: number): T {
  return arr[index % arr.length];
}

export function randomInt(min: number, max: number): number {
  return Math.floor(next() * (max - min + 1)) + min;
}

export function randomFloat(min: number, max: number, decimals = 2): number {
  return parseFloat((next() * (max - min) + min).toFixed(decimals));
}

export function randomBool(trueChance = 0.5): boolean {
  return next() < trueChance;
}

export function uuid(): string {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
    const r = (next() * 16) | 0;
    return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16);
  });
}

let _seq = 0;
export function seq(): number {
  return ++_seq;
}

export function daysFromNow(offset: number): string {
  const d = new Date();
  d.setDate(d.getDate() + offset);
  return d.toISOString().slice(0, 10);
}

export function isoNow(offsetDays = 0): string {
  const d = new Date();
  d.setDate(d.getDate() + offsetDays);
  return d.toISOString();
}

export function randomDate(daysBefore: number, daysAfter: number): string {
  return daysFromNow(randomInt(daysBefore, daysAfter));
}

export function randomEmail(firstName: string, lastName: string): string {
  const domains = ['example.com', 'test.com', 'mock.dev', 'email.test'];
  return `${firstName.toLowerCase()}.${lastName.toLowerCase()}@${pick(domains)}`;
}

export function randomPhone(): { prefix: string; number: string } {
  const prefixes = ['+34', '+1', '+44', '+49', '+33', '+351'];
  return {
    prefix: pick(prefixes),
    number: String(randomInt(600000000, 699999999)),
  };
}
